import { useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useChatStore } from '../store/chatStore'
import { useSocket } from '../hooks/useSocket'

// Components
import Sidebar from '../components/chat/Sidebar'
import ChatWindow from '../components/chat/ChatWindow'
import Welcome from '../components/chat/Welcome'
import UserProfile from '../components/chat/UserProfile'
import SearchModal from '../components/chat/SearchModal'
import CreateChatModal from '../components/chat/CreateChatModal'

const Chat = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [showUserProfile, setShowUserProfile] = useState(false)
  const [showSearchModal, setShowSearchModal] = useState(false)
  const [showCreateChatModal, setShowCreateChatModal] = useState(false)
  
  const { currentChat, fetchChats } = useChatStore()
  const { isConnected } = useSocket()

  useEffect(() => {
    // Fetch user's chats on component mount
    fetchChats()
  }, [fetchChats])

  return (
    <div className="h-screen flex bg-gray-50 dark:bg-gray-900">
      {/* Sidebar */}
      <div className={`${sidebarOpen ? 'w-80' : 'w-0'} transition-all duration-300 overflow-hidden`}>
        <Sidebar
          onToggle={() => setSidebarOpen(!sidebarOpen)}
          onShowProfile={() => setShowUserProfile(true)}
          onShowSearch={() => setShowSearchModal(true)}
          onShowCreateChat={() => setShowCreateChatModal(true)}
        />
      </div>

      {/* Main Chat Area */}
      <div className="flex-1 flex flex-col min-w-0">
        <Routes>
          <Route path="/" element={currentChat ? <ChatWindow /> : <Welcome />} />
          <Route path="/:chatId" element={<ChatWindow />} />
        </Routes>
      </div>

      {/* Connection Status */}
      {!isConnected && (
        <div className="fixed top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg z-50">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <span className="text-sm font-medium">Reconnecting...</span>
          </div>
        </div>
      )}

      {/* Modals */}
      {showUserProfile && (
        <UserProfile 
          isOpen={showUserProfile}
          onClose={() => setShowUserProfile(false)} 
        />
      )}

      {showSearchModal && (
        <SearchModal 
          isOpen={showSearchModal}
          onClose={() => setShowSearchModal(false)} 
        />
      )}

      {showCreateChatModal && (
        <CreateChatModal 
          isOpen={showCreateChatModal}
          onClose={() => setShowCreateChatModal(false)} 
        />
      )}

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  )
}

export default Chat